// extracted by mini-css-extract-plugin
export default {"chip":"CIVuCe0DA77YtB8u8k2B","icon":"ZMxY29ZOcOfyaeXEacqw"};